import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

interface TimeInputProp extends UpdateTermineFormProps {
  name: 'beginn' | 'ende';
}

export function TimeInputFormField({ name, form }: TimeInputProp) {
  const { t } = useTranslation();

  return (
    <form.AppField name={name}>
      {(field) => (
        <field.TimeInput
          label={
            name === 'ende'
              ? t('domain.termine.sheet.fields.bis')
              : t('domain.termine.sheet.fields.von')
          }
          className={cn(
            'w-full md:w-20',
            name === 'ende' &&
              field.state.meta.errors.length > 0 &&
              'border-primary-red-400',
          )}
        />
      )}
    </form.AppField>
  );
}
